export default {"src":"/trader-new/_next/static/media/ast.ab9da6d5.svg","height":246,"width":173,"blurWidth":0,"blurHeight":0};